<template>
    <div v-if="resolvedTabs.length" :style="`margin-inline-start:10px;padding:5px;width:100%;margin-top:10px !important;direction:${componentLang.dir || 'ltr'}`" class="mt-10">
        <div style="display:inline-flex;padding:0 5px" v-for="(tab,index) of resolvedTabs" :key="index">
            <b-button v-if="tab.class == 'mytab' && tab.style == '' && checkIf(index)" style="background:#000 !important;font-weight:bold;" :class="`btn-sm btn tabBtn `+tab.smclass" @click='goTo(tab.href,tab.main)'>{{ resolveTabName(tab) }}  <i class="fas fa-arrow-down"></i></b-button>
            <b-button v-else-if="tab.class == 'mytab' && tab.style != '' && checkIf(index)" :style="`background:#000 !important;font-weight:bold;`+tab.style" :class="`btn-sm btn tabBtn `+tab.smclass" @click='goTo(tab.href,tab.main)'>{{ resolveTabName(tab) }}  <i class="fas fa-arrow-down"></i></b-button>
            <b-button v-else-if="checkIf(index)" :class="`btn-sm btn tabBtn `+tab.smclass" :style="`background:#eee !important;color:black !important;font-weight:bold;`+tab.style" @click='goTo(tab.href,tab.main)'>{{ resolveTabName(tab) }} </b-button>
        </div>
        <div style="display:none;padding:0 5px" v-for="(tab,index) of resolvedTabs" :key="index">
          <button v-if="tab.class == 'mytab' && tab.style == '' && checkIf(index)" class="cssbuttons-io-button" style="background-image: linear-gradient(19deg, #aaa 0%, #000 100%) !important;" @click='goTo(tab.href,tab.main)'> {{ resolveTabName(tab) }}
            <div class="icon">
              <i class="fas fa-arrow-down" style="color:#000"></i>
            </div>
          </button>
          <button v-else-if="tab.class == 'mytab' && tab.style != '' && checkIf(index)" class="cssbuttons-io-button" @click='goTo(tab.href,tab.main)'> {{ resolveTabName(tab) }}
            <div class="icon">
              <i class="fas fa-arrow-down" style="color:#000"></i>
            </div>
          </button>
          <button v-else-if="checkIf(index)" class="cssbuttons-io-button" @click='goTo(tab.href,tab.main)' style="color:black !important;"> {{ resolveTabName(tab) }}
            <div class="icon">
              <i class="fas fa-arrow-left"></i>
            </div>
          </button>
          
            <b-button v-if="tab.class == 'mytab' && tab.style == '' && checkIf(index)" style="display:none;background:#000 !important;font-weight:bold;" :class="`btn-sm btn tabBtn `+tab.smclass" @click='goTo(tab.href,tab.main)'>{{tab.name}}  <i class="fas fa-arrow-down"></i></b-button>
            <b-button v-else-if="tab.class == 'mytab' && tab.style != '' && checkIf(index)" :style="`display:none;background:#000 !important;font-weight:bold;`+tab.style" :class="`btn-sm btn tabBtn `+tab.smclass" @click='goTo(tab.href,tab.main)'>{{tab.name}}  <i class="fas fa-arrow-down"></i></b-button>
            <b-button v-else-if="checkIf(index)" :class="`btn-sm btn tabBtn `+tab.smclass" :style="`display:none;background:#eee !important;color:black !important;font-weight:bold;`+tab.style" @click='goTo(tab.href,tab.main)'>{{tab.name}} </b-button>
        </div>

    </div>
</template>
<script>
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { canShowMenuItem, getVisibleTabsForMatchedRoute, getVisibleTabsForRoute } from '@/menu/menuService'

export default{
    props: [
      'tabs'
    ],
    computed: {
        componentLang(){
          if(this.$parent && this.$parent.lang){
            return this.$parent.lang;
          }

          const state = this.$store && this.$store.getters
            ? this.$store.getters['state']
            : this.$store.state;
          const langKey = state && state.deflang ? state.deflang : 'ar';

          return state && state.lang && state.lang[langKey]
            ? state.lang[langKey]
            : {};
        },
        resolvedTabs(){
          const state = this.$store && this.$store.getters
            ? this.$store.getters['state']
            : this.$store.state;
          const matchedTabs = getVisibleTabsForMatchedRoute(state, this.componentLang, this.$route.path);

          if(matchedTabs.length){
            return matchedTabs;
          }

          if(Array.isArray(this.tabs) && this.tabs.length){
            return this.tabs;
          }

          return getVisibleTabsForRoute(state, this.componentLang, this.$route.path);
        },
    },
    methods: {
        checkIf(index){
          const tab = this.resolvedTabs && this.resolvedTabs[index];
          return canShowMenuItem(tab, this.$store.state);
        },
        resolveTabName(tab){
          if(!tab) return '';
          const routeKeyMap = {
            '/inventory/vendors': 'vendors',
            '/purchase-order': 'purchase_order',
            '/purchase': 'purchase',
            '/purchaseReturn': 'purchase_return',
            '/return-purchase': 'purchase_return',
            '/purchase-report': 'purchase_report',
            '/purchase-requests': 'purchase_requests',
          };
          const key = routeKeyMap[tab.href];
          if(key && this.$parent && this.$parent.lang && this.$parent.lang[key]){
            return this.$parent.lang[key];
          }
          return tab.name;
        },
        goTo(path,main){
            localStorage.setItem("currentMenu",main);
            this.$router.push({path: path})
        },
        checkLink(){
          const tabs = this.resolvedTabs || [];
          if(!tabs.length){
            return;
          }

          let t = false;
          let path = '';
          for(let i=0;i<tabs.length;i++){
            if(this.$route.path == tabs[i].href){
              t = true
            }
            if(i == 0){
              path = tabs[i].href;
            }
          }
          // // console.log("tt",t);
          if(!t){
            this.$router.push({path: path})
          } 
        }
    },
    created() {
      setTimeout(() => {this.checkLink()},1000)
    },
}
</script>

<style>
.mytab{
  width:100%;
  border:0px solid #fff;
}
.mytab2{
  width:100%;
  background:rgb(4, 112, 155) !important;
  color:#FFF;
  border:0px solid #fff;
}
.mytab4{
  width:100%;
  background:rgb(15, 90, 230) !important;
  border:0px solid #fff;
}
.mytab3{
  width:100%;
  background:#198754 !important;
  border:0px solid #fff;
}
.mytab1{
  width:100%;
  background:#fe7b33 !important;
  border:0px solid #fff;
}
.mytab5{
  width:100%;
  background:#339cfe !important;
  border:0px solid #fff;
}
.mytab6{
  width:100%;
  background:#fe3344 !important;
  border:0px solid #fff;
}
.font-small{
  font-size:.8em !important;
  width:120px !important;
}
.tabBtn{
  white-space: nowrap;
  width:125px;
  font-size:0.8rem;
}
@media  only screen and (max-width: 1100px){
    .btn-sm{
      font-size:.6rem !important;
    }
    .tabBtn{
        width:100px;
        font-size:.7rem;
    }
    .refIcon{
        top:30px;
        left: 10px;
        font-size:.6rem;

    }
}
</style>
